@if (selectedChangeType() === MeterPointChangeType.EMPTY_TO_OCCUPIED) {
  <ikp-empty-contract-partner [parentForm]="this.form" />
}
@if (selectedChangeType() === MeterPointChangeType.OCCUPIED_TO_EMPTY || selectedChangeType() === MeterPointChangeType.TENANT_CHANGE) {
  <ikp-occupied-contract-partner [parentForm]="this.form" />
}
